/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { Form, Button } from 'reactstrap'
import { API } from "../../../config/api";
import { FaEdit, FaTimes } from 'react-icons/fa'
import Modal from 'react-bootstrap/Modal';
import { useMutation } from "react-query";
import "bulma/css/bulma.css";
import "../Styled.css"
import Swal from "sweetalert2";
import swal from "sweetalert";
import LoaderHome from "../../Loader/LoaderHome"
import axios from "axios";
import { Badge } from "react-bootstrap";
import ModalContentReusable from "../../Global/ModalContent";
// generate s

export default function ModalPatientDetail(props) {
    const token = localStorage.getItem("token");
    const [loading, setLoading] = useState(false);
    // Untuk Close Proops Data
    const [propsData, setProopsData] = useState()
    const [getDataCode, setGetCode] = useState()
    const [page, setPage] = useState(1);
    const [limit] = useState(10);
    const [pages, setPages] = useState();
    const [ascending] = useState(0);
    const [getProvince, setGetProvince] = useState([])
    const [getRegency, setGetRegency] = useState([])
    const [getDistrict, setGetDistrict] = useState([])
    const [getSubDistrict, setGetSubDistrict] = useState([])
    const [provinceLoaded, setProvinceLoaded] = useState(false);
    const [cityLoaded, setCityLoaded] = useState(false);
    const [districtLoaded, setDistrictLoaded] = useState(false);
    const [getDataCoba, setGetDataCoba] = useState([])
    const [getDataTokenSatuSehat, setGetDataTokenSatuSehat] = useState([]);
    const [modalShow, setModalShow] = useState(false);
    const [errors, setErrors] = useState({});
    return (
        <ModalContentReusable
            isOpen={props.show}
            isClose={props.onHide}
            //   handleSubmit={handleSubmit.mutate}
            //   handleChange={handleChange}
            size="md"
            title="Detail Pasien"
        >
            <div
                className="card p-4"
                style={{
                    maxWidth: "400px",
                    margin: "auto",
                    borderRadius: "10px",
                    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                    textAlign: "center",
                }}
            >
                {/* Foto Profil */}
                <div className="card-image">
                    <figure className="image is-128x128" style={{ margin: "auto" }}>
                        <img
                            src={
                                "https://storageapps.signatureanugerah.co.id/public/images/no-profile.png"
                            }
                            alt="Foto Pasien"
                            style={{ borderRadius: "50%", border: "2px solid #C9C9C9" }}
                        />
                    </figure>
                </div>

                {/* Informasi Pasien */}
                <div className="card-content">
                    <div className="content">
                        <h3 className="title is-6" style={{ marginBottom: "5px", fontWeight: "bold" }}>
                            <span style={{ display: "flex", justifyContent: "center", gap: "3px" }}>
                                {props?.firstNamePastient} {props?.lastNamePatient}
                            </span>
                            <p className="subtitle is-7 mt-1" style={{ color: "#666", marginBottom: "10px" }}>
                                Kode Pasien:
                                <strong>{props?.codePatient || "N/A"}</strong>
                            </p>
                        </h3>
                        <hr />
                        <div style={{ textAlign: "left", fontSize: "14px", lineHeight: "1.6" }}>
                            <p><strong>Jenis Kelamin :</strong>
                                {props?.genderPatient === 'male' ? 'Laki-Laki' : 'Perempuan' || " - "}
                            </p>
                            <p><strong>Tanggal Lahir :
                            </strong>
                                {props?.dateBirthPatient
                                    ? new Date(props.dateBirthPatient).toLocaleDateString("id-ID", {
                                        day: "2-digit",
                                        month: "long",
                                        year: "numeric",
                                    })
                                    : "-"}
                            </p>
                            <p><strong>Usia :</strong>
                                {props?.agePatient || " - "} tahun
                            </p>
                            <p>
                                <strong>Alamat :</strong>
                                {props?.residenceAddressPatient || " - "}
                            </p>
                            <p><strong>Alamat (KTP) :</strong>
                                {props?.nicAddPatient || " - "}
                            </p>
                            <p><strong>Nomor HP :</strong>
                                {props?.phoneNUmberPatient || " - "}
                            </p>
                            <p><strong>NIK :</strong>
                                {props?.nicNUmberPatient || " - "}
                            </p>
                            <p><strong>Pekerjaan :</strong>
                                {props?.occupationPatient || " - "}
                            </p>
                            <p>
                                <div style={{ display: "flex" }}>
                                    <strong>No. Rekam Medis :</strong>
                                    {props?.medicalRecordCodePatient}
                                </div>
                            </p>
                            <p><strong>Email :</strong>
                                {props?.emailPatient || " - "}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </ModalContentReusable>
    );
}


